import type { FunctionComponent } from 'react';

import { useTrophy } from '../../../hooks/helpers/useTrophy';

import { TrophyIcon } from './TrophyIcon';

export const TrophyIconConnected: FunctionComponent = () => {
  const trophy = useTrophy();

  return <TrophyIcon trophy={trophy} />;
};
